import React, { useState, useEffect } from 'react'
import ReactQuill from "react-quill"
import 'react-quill/dist/quill.snow.css'

const toolbar = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{ 'align': ''}, { 'align': 'right'}, { 'align': 'center'}, { 'align': 'justify'}],
    //['blockquote', 'code-block'],
    //['link', 'image'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
  
    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
  
    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    //['clean']
];
export default function Editor ({ value = '', onChange, onKeyPress, onFocus, onBlur, readOnly = false, placeholder, disabled }) {
  const [convertedText, setConvertedText] = useState(value)

  const onChageText = (e) => {
    setConvertedText(e)
    if (onChange) {
      onChange(e)
    }
  }

  const onKeyDown = (e) => {}

  useEffect(() => {
    setConvertedText(value)
  }, [value])
  
  return (
      <ReactQuill
        theme='snow'
        className={`${readOnly ? 'ql-readonly' : ''}`}
        modules= {{
          toolbar 
        }}
        readOnly={readOnly}
        disabled={disabled}
        onChange={onChageText}
        onKeyPress={onKeyPress}
        onKeyUp={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        value={convertedText}
        placeholder={placeholder}
      />
  );
}